import styled, { css, keyframes } from 'styled-components';

export const EndSessionModalWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  display: ${(props) => (props.show ? 'flex' : 'none')};
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.3);
  top: 0px;
  left: 0px;
  z-index: 5;
`;

export const EndSessionModalContent = styled.div`
  width: 70%;
  padding: 25px;
  border-radius: 20px;
  background-color: #ffffff;
  box-shadow: 0px 8px 13px ${(props) => props.theme.colorStyled.ColorBgDefaultShadow};
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 300px;

  @media (max-width: 440px) {
    & > span:first-child ~ span {
      width: 90% !important;
    }
    #h-space {
      width: 0px !important;
    }
  }

  & > span:first-child {
    font-size: 29px;
    font-weight: 400;
    margin-bottom: 24px;
  }

  & > span:first-child ~ span {
    line-height: 16px;
    font-weight: 600;
    font-size: 13px;
    width: 70%;
    text-align: center;
  }
  .action-stack {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    align-items: center;
    flex-wrap: wrap;
  }
`;

export const ActionButton = styled.button`
  background-color: ${(props) => props.bgColor || '#F99D1D'};
  border-radius: 10px;
  width: fit-content;
  height: fit-content;
  padding: 8px;
  padding-left: 30px;
  padding-right: 30px;
  font-size: 14px;
  color: white;
  border: 0px solid transparent;
  margin-bottom: 10px;
  font-weight: 400px;

  &:hover {
    opacity: 0.8;
  }

  img {
    width: 10px;
    height: 10px;
    position: relative;
    top: 1px;
    left: 3px;
    transition: linear 120ms;
  }

  img.collapsed-icon {
    transform: rotate(180deg);
    transition: linear 120ms;
  }
`;
